module.exports = __webpack_public_path__ + "static/media/BackgroundTexture-LP.31d2fee8.jpg";